import { render, staticRenderFns } from "./TrendyolIcon.vue?vue&type=template&id=69175fc9&scoped=true"
import script from "./TrendyolIcon.vue?vue&type=script&lang=js"
export * from "./TrendyolIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69175fc9",
  null
  
)

export default component.exports